import styled from '@emotion/styled'

import { convertNumberToPercentage } from '@/modules/tradebuilder-v2/util'

import { ApiAssetWeightWithDifference, ApiInvestmentAssetWeightWithDifference } from './types'

const StyledAssetTable = styled.table`
  white-space: break-spaces;
  margin-bottom: 20px;
  & > tbody tr {
    border-top: 1px solid var(--White90);
    border-bottom: 1px solid var(--White90);
  }
  & th {
    padding: 16px;
    font-weight: normal;
  }
  .table-asset {
    text-align: left;
    vertical-align: bottom;
  }
  .table-data {
    text-align: right;
  }
  & > tbody tr:nth-of-type(1) {
    border-top: 1px solid var(--White80);
  }
  & > tbody tr:last-of-type {
    border-bottom: 1px solid var(--White80);
  }
`

const StyledHighlightableTr = styled.tr<{ highlighted: boolean }>`
  background: ${props => (props.highlighted ? 'var(--InfoBG)' : 'transparent')};
  & > th {
    font-weight: ${props => (props.highlighted ? 'bold' : 'normal')};
  }
`

interface ProposedChangeAssetTableProps {
  assetList: ApiAssetWeightWithDifference[]
  investmentAssetList: ApiInvestmentAssetWeightWithDifference[]
}

export const ProposedChangeAssetTable = ({
  assetList,
  investmentAssetList
}: ProposedChangeAssetTableProps) => (
  <StyledAssetTable>
    <thead>
      <tr>
        <th className="table-asset">Asset</th>
        <th className="table-data">{'Target\nweight (%)'}</th>
        {investmentAssetList?.length > 0 && (
          <th className="table-data">{'Investment\nweight (%)'}</th>
        )}
      </tr>
    </thead>
    <tbody>
      {assetList.map((assetWeight, i) => (
        <StyledHighlightableTr
          key={`asset-${assetWeight.asset.assetId}`}
          aria-label={assetWeight.different ? 'Changed asset' : 'Asset'}
          data-testid="changes-asset-row"
          highlighted={assetWeight.different || investmentAssetList[i]?.different}
        >
          <th className="table-asset">{assetWeight.asset.name}</th>
          <th className="table-data">{convertNumberToPercentage(assetWeight.weight)}</th>
          {investmentAssetList?.length > 0 && investmentAssetList[i] && (
            <th className="table-data">
              {convertNumberToPercentage(investmentAssetList[i].weight)}
            </th>
          )}
        </StyledHighlightableTr>
      ))}
    </tbody>
  </StyledAssetTable>
)
